import React, { useEffect, useState } from 'react';
import Snippet from '../Snippet';

interface PdfSelectorProps {
  onPdfSelect: (slug: string) => void;
}

export const PdfSelector: React.FC<PdfSelectorProps> = ({ onPdfSelect }) => {
  const pdfButtonClass =
    'no-underline p-2 bg-black text-white rounded-md text-center';
  const [slug, setSlug] = useState('matt-lack');

  useEffect(() => {
    onPdfSelect(slug);
  }, [slug, onPdfSelect]);
  return (
    <>
      <Snippet page="pdf" props={`pdfName="${slug}"`} />
      <div className="flex flex-col gap-5 border-b-2 border-black pb-3 pl-4 mb-2">
        <label>Välj en manual:</label>
        <div className="flex flex-row gap-5 pl-2">
          <button
            onClick={() => setSlug('matt-lack')}
            className={pdfButtonClass}
          >
            Mattlack
          </button>
        </div>
      </div>
    </>
  );
};
